<template>
    <div class="dv-version">
        <h1 style="text-align:left;"> Version Program Fillgoods</h1>
        <el-row :gutter="20" justify="center">
            <el-col :span="10">
                <el-card>
                    <el-form ref="form" :model="formVersion" label-width="200px">
                        <el-form-item label="DEV - version">
                            <el-input v-model="formVersion.dev"></el-input>
                        </el-form-item>
                        <el-form-item label="UAT - version">
                            <el-input v-model="formVersion.uat"></el-input>
                        </el-form-item>
                        <el-form-item label="PRODUCTION - version">
                            <el-input v-model="formVersion.prod"></el-input>
                        </el-form-item>
                        <el-form-item label="OMS uat/prod - version">
                            <el-input v-model="formVersion.oms"></el-input>
                        </el-form-item>
                        <el-form-item label="OMS dev - version">
                            <el-input v-model="formVersion.omsDev"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-button type="success" @click="saveVersion">บันทึก</el-button>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'VersionControl',
    data () {
        return {
            formVersion: {
                dev: '',
                uat: '',
                prod: '',
                oms: '',
                omsDev: ''
            },
            dbFG: {
                dev: null,
                uat: null,
                prod: null,
                oms: null,
                omsDev: null
            }
        }
    },
    async created () {
        this.$loading()
        this.dbFG.dev = this.$store.get('fgFirbaseApp/dev').firestore()
        this.dbFG.uat = this.$store.get('fgFirbaseApp/uat').firestore()
        this.dbFG.prod = this.$store.get('fgFirbaseApp/prod').firestore()
        this.dbFG.oms = this.$store.get('fgFirbaseApp/oms').firestore()
        this.dbFG.omsDev = this.$store.get('fgFirbaseApp/omsDev').firestore()
        // Dev
        let docDev = await this.dbFG.dev.collection('version').doc('dev').get()
        if (docDev.exists) {
            this.formVersion.dev = docDev.data().value
        } else {
            console.log('No such document!')
        }
        // Uat
        let docUat = await this.dbFG.uat.collection('version').doc('uat').get()
        if (docUat.exists) {
            this.formVersion.uat = docUat.data().value
        } else {
            console.log('No such document!')
        }
        // Prod
        let docProd = await this.dbFG.prod.collection('version').doc('prod').get()
        if (docProd.exists) {
            this.formVersion.prod = docProd.data().value
        } else {
            console.log('No such document!')
        }
        // OMS uat / prod
        let docOMS = await this.dbFG.oms.collection('version').doc('oms').get()
        if (docOMS.exists) {
            this.formVersion.oms = docOMS.data().value
        } else {
            console.log('No such document!')
        }
        // OMS Dev
        let docOmsDev = await this.dbFG.omsDev.collection('version').doc('oms').get()
        if (docOmsDev.exists) {
            this.formVersion.omsDev = docOmsDev.data().value
        } else {
            console.log('No such document!')
        }
        console.log(this.formVersion)
        this.$loading().close()
    },
    methods: {
        async saveVersion () {
            try {
                this.$loading()
                await this.dbFG.dev.collection('version').doc('dev').set({ value: this.formVersion.dev })
                await this.dbFG.uat.collection('version').doc('uat').set({ value: this.formVersion.uat })
                await this.dbFG.prod.collection('version').doc('prod').set({ value: this.formVersion.prod })
                await this.dbFG.oms.collection('version').doc('oms').set({ value: this.formVersion.oms })
                await this.dbFG.omsDev.collection('version').doc('oms').set({ value: this.formVersion.omsDev })
                this.$message({ type: 'success', message: 'บันทึกข้อมูลเรียบร้อย' })
            } catch (error) {
                this.$message.error({ message: 'ระบบผิดพลาด' })
            }
            this.$loading().close()
        }
    }
}
</script>
